  import React, { useState } from 'react';
  import styled from 'styled-components';
  import { FaEdit } from 'react-icons/fa';
  import Lottie from 'react-lottie'
  import closeAnimation from '../Assets/icons/close.json';
  import ChevronDownIcon from '../Assets/icons/chevron.svg';
  import useIAProfileData from '../Hooks/IAprofileHooks/useIaProfile';
  import IAProfileEdit from './iaProfilingEdit';


  import { NumberChevronWrapper, ChevronWrapper, ChevronIcon, EditLabel, darkMode } from './StyledComponents';

  const ProfileSlide =  ({ setShowIAProfiling,  darkMode }) => {
    const [selectedItem, setSelectedItem] = useState(null); 
    const [showEditPanel, setShowEditPanel] = useState(false)
    const [showAddPanel, setShowAddPanel] = useState(false);
    const { data, loading, error } = useIAProfileData();
    

    const closePanel = () => {
      setShowIAProfiling(false); 
    }; 
    const [ setIsEditVisible] = useState(false);
    const [showProfiling, setShowProfiling] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const handleAddData = () => {
      setShowAddPanel(true); 
    };

    const handleEditData = (item) => {
      setSelectedItem(item); 
      setShowEditPanel(true);
    };

    const closeAddPanel = () => {
      setShowAddPanel(false); // Close the Add panel
    }

    const closeEditPanel = () => {
      setShowEditPanel(false); // Hide the slide-in panel
      setSelectedItem(null); // Clear the selected item
    };

    const toggleEditVisibility = () => {
      setIsEditVisible((prev) => !prev);
    };

    const handleSlideIn = () => {
      setShowProfiling(true);
    };

    const filteredData = data.filter(item =>
      (item.iaName?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
      (item.municipality?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
      (item.iaPresident?.toLowerCase() || '').includes(searchQuery.toLowerCase())
    );
    
    if (loading) {
      return <div>Loading...</div>; 
    }
  
    if (error) {
      return <div>Error: {error.message}</div>; 
    }

    return (
      <SlidingPanel show={true}>
      <CloseButton onClick={closePanel}>
          <Lottie options={{ animationData: closeAnimation, loop: false, autoplay: true }} height={30} width={30} />
        </CloseButton>
      <Container darkMode={darkMode}>
        <Header darkMode={darkMode} >
          <Heading>IRRIGATORS ASSOCIATION</Heading>
        </Header>

        <SearchContainer>
            <SearchInput 
              type="text" 
              placeholder="Search Municipality..." 
              value={searchQuery} 
              onChange={(e) => setSearchQuery(e.target.value)} 
            />
          </SearchContainer>


          <TableWrapper darkMode={darkMode} showAddPanel={showAddPanel}>
          <Table >
            <thead>
              <tr>
              <TableHeader  darkMode={darkMode}>No</TableHeader>
                <TableHeader  darkMode={darkMode}>NAME OF IRRIGATORS' ASSOCIATION</TableHeader>
                <TableHeader  darkMode={darkMode}>Name of CIS/SIS-SRIS/SIP/PIP/SRIP</TableHeader>
                <TableHeader  darkMode={darkMode}>MUNICIPALITY</TableHeader>
                <TableHeader  darkMode={darkMode}>District No.</TableHeader>
                <TableHeader  darkMode={darkMode}>Mailing Address</TableHeader>
                <TableHeader  darkMode={darkMode}>Name of IA President</TableHeader>
                <TableHeader  darkMode={darkMode}>Contact Number</TableHeader>
                <TableHeader  darkMode={darkMode}>Date Organized</TableHeader>
                <TableHeader darkMode={darkMode} colSpan="2" style={{ textAlign: 'center' }}>
                         SEC / CDA / DOLE Reg
                </TableHeader>
                <TableHeader  darkMode={darkMode}>IA TIN</TableHeader>

                <TableHeader  darkMode={darkMode}colSpan="2" style={{ textAlign: 'center' }}>
                  Water Permit 
                </TableHeader>
              
                <TableHeader  darkMode={darkMode}colSpan="2" style={{ textAlign: 'center' }}>
                  Membership </TableHeader>
            
                <TableHeader  darkMode={darkMode}>No. of TSAG</TableHeader>
                <TableHeader  darkMode={darkMode}>Service Area</TableHeader>
                <TableHeader  darkMode={darkMode}>FUSA</TableHeader>
                <TableHeader  darkMode={darkMode}>Operational Area</TableHeader>

                <TableHeader  darkMode={darkMode}colSpan="4" style={{ textAlign: 'center' }}>
                  ORIGINAL CONSTRUCTION</TableHeader>

                <TableHeader  darkMode={darkMode}>Total IA Loan Balance</TableHeader>
                <TableHeader  darkMode={darkMode}>Status</TableHeader>

                <TableHeader  darkMode={darkMode}colSpan="2" style={{ textAlign: 'center' }}>
                  IMT CONTRACT </TableHeader>

                <TableHeader  darkMode={darkMode}colSpan="2" style={{ textAlign: 'center', borderBottom: '1px' }}>
                  CANAL LENGTH</TableHeader>
          
                <TableHeader  darkMode={darkMode}>Remarks</TableHeader>
              </tr>

              <tr>
              <TableHeaderS  colSpan="1" darkMode={darkMode}></TableHeaderS>
             <TableHeaderS  colSpan="8" darkMode={darkMode}></TableHeaderS>
             <TableHeaderS darkMode={darkMode}>Number</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>Date</TableHeaderS>
            <TableHeaderS  colSpan="1" darkMode={darkMode}></TableHeaderS>
            <TableHeaderS darkMode={darkMode}>Number</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>Date</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>POT'L</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>ACTUAL</TableHeaderS>
            <TableHeaderS  colSpan="4" darkMode={darkMode}></TableHeaderS>
            <TableHeaderS darkMode={darkMode}>DATE of MOA signed</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>F-Source</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>Proj Cost ('000)</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>DATE of TURNOVER</TableHeaderS>
            <TableHeaderS  colSpan="2" darkMode={darkMode}></TableHeaderS>
            <TableHeaderS darkMode={darkMode}>DATE OF SIGNING</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>AREA UNDER CONTRACT</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>UNLINED</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>LINED</TableHeaderS>
            <TableHeaderS  colSpan="1" darkMode={darkMode}></TableHeaderS>

           </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => (
               <TableRow key={item.id} darkMode={darkMode}>
               <TableData>
               {index + 1}
              <ChevronWrapper>
               <ChevronIcon src={ChevronDownIcon} alt="Chevron" />
    
              <EditLabel onClick={() => handleEditData(item)}> Edit</EditLabel>
               </ChevronWrapper>
               </TableData>
                  
               <TableData darkMode={darkMode}>{item.name_of_irrigators}</TableData>
                  <TableData darkMode={darkMode}>{item.name_of_cis}</TableData>
                  <TableData darkMode={darkMode}>{item.municipality}</TableData>
                  <TableData darkMode={darkMode}>{item.district_number}</TableData>
                  <TableData darkMode={darkMode}className="station-mail">{item.mailing_address}</TableData>
                  <TableData darkMode={darkMode}className="station-iaPres">{item.name_of_iaPresident}</TableData>
                  <TableData darkMode={darkMode}>{item.contactNumber}</TableData>
                  <TableData darkMode={darkMode}>{item.date_organized}</TableData>
                  <TableData darkMode={darkMode}className="station-secNum">{item.sec_number}</TableData>
                  <TableData darkMode={darkMode}className="station-secDate">{item.sec_date}</TableData>  
                  <TableData darkMode={darkMode}className="station-iaTin">{item.ia_tin}</TableData>
                  <TableData darkMode={darkMode}>{item.permit_number}</TableData>
                  <TableData darkMode={darkMode}className="station-permitDate">{item.permit_date}</TableData>
                  <TableData darkMode={darkMode}>{item.membership_potl}</TableData>
                  <TableData darkMode={darkMode}>{item.membership_actual}</TableData>
                  <TableData darkMode={darkMode}>{item.number_of_TSAG}</TableData>
                  <TableData darkMode={darkMode}>{item.serviceArea}</TableData>
                  <TableData darkMode={darkMode}>{item.fusa}</TableData>
                  <TableData darkMode={darkMode}>{item.operational_area}</TableData>
                  <TableData darkMode={darkMode}className="station-dateMoa">{item.date_moaSigned}</TableData>
                  <TableData darkMode={darkMode}>{item.f_source}</TableData>
                  <TableData darkMode={darkMode}>{item.proj_cost}</TableData>
                  <TableData darkMode={darkMode}className="station-turnover">{item.date_turnover}</TableData>
                  <TableData darkMode={darkMode}>{item.total_loanBalance}</TableData>
                  <TableData darkMode={darkMode}>{item.status}</TableData>
                  <TableData darkMode={darkMode}>{item.imtContract_dateSigning}</TableData>
                  <TableData darkMode={darkMode}>{item.imtContract_underContract}</TableData>
                  <TableData darkMode={darkMode}>{item.canalLength_unlined}</TableData>
                  <TableData darkMode={darkMode}>{item.canalLength_lined}</TableData>
                  <TableData darkMode={darkMode}>{item.remarks}</TableData>
                </TableRow>
              ))}
            </tbody>
          </Table>
        </TableWrapper>
  {showEditPanel && <IAProfileEdit selectedItem={selectedItem} closeEditPanel={closeEditPanel} />}

      </Container>
      </SlidingPanel>
    );
  };

  export default  ProfileSlide;

  const Container = styled.div`
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(42, 48, 42)' : '#f8f9fa')};
    padding: 10px;
    min-height: 100vh;
    overflow-y: auto;
    margin-left: -15px;
    margin-top:  -55px;
  `;

  const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: -5px;
    margin-bottom: 20px;
    margin-top: 25px;
  `;

  const Heading = styled.h2`
    font-size: 20px;
    color: #333;
    font-weight: bold;
    text-transform: uppercase;
    font-family: 'Poppins', sans-serif;
    margin-bottom: 20px;
  `;

  const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
  `;

  const Button = styled.button`
    font-size: 15px;
    color: ${(props) => props.textColor || '#000'};
    background-color: ${(props) => props.bgColor || '#ddd'};
    border: none;
    padding: 3px 20px;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 15px;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: ${(props) => props.hoverColor || '#28a745'};
    }
  `;

  const TableWrapper = styled.div`
  width: 100%;
  height: 75vh;
 overflow: auto; 
 margin-top: 10px;
  position: relative;
background-color: ${({ darkMode }) => (darkMode ? 'rgb(42, 48, 42)' : '#f2f2f2')};

`;

  const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    min-width: 1500px;
  `;

  const TableHeader = styled.th`
  position: sticky;
  background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : 'rgb(37, 112, 46)')};
  padding: 0 20px;
  height: 10px;
  top: 0px;

  z-index: 2;
  text-align: center;  /* Center text horizontally */
  vertical-align: middle; 
  border-left: 1px solid #ddd; /* Keep left border */
  border-right: 1px solid #ddd; /* Keep right border */
  border-top: 1px solid #ddd; /* Keep top border */
  border-bottom: none;
  font-size: 14px;
  color: ${({ darkMode }) => (darkMode ? '#333' : '#fff')};
  margin-top: 10px;

   &:first-child {
    position: sticky;
    left: 0;
    z-index: 3; /* Ensure it's above the other headers */
    background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : 'rgb(37, 112, 46)')}; 
  }

   &[colspan="2"] {
    text-align: center;
    font-weight: bold;
  }
`;

  const TableHeaderS = styled.th`
  background-color: ${({ darkMode }) => (darkMode ? 'rgb(36, 110, 45)' : '#f2f2f2')};
 padding: 0 10px;
  top: 39px;
  position: sticky;
  z-index: 1;
  text-align: center;
  border-left: 1px solid #ddd; /* Keep left border */
  border-right: 1px solid #ddd; /* Keep right border */
  border-top: 1px solid #ddd; 
  border-bottom: 2px solid #ddd;
  font-size: 12px;
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};

   &:first-child {
    position: sticky;
    left: 0;
    z-index: 3; /* Ensure it's above the other headers */
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(25, 88, 32)' : '#f2f2f2')}; /* Ensure it matches the background */
  }

   &[colspan="2"] {
    text-align: center;
    font-weight: bold;
  }
`;

const TableData = styled.td`
  padding: 5 5px;
  font-size: 12px;
  text-align: center;
  border: 1px solid #ddd;
  color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
  transition: background-color 0.3s ease, color 0.3s ease;

  &:first-child {
    position: sticky;
    left: 0;
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)2' : '#f2f2f2')}; 
   };
    z-index: 1;
  }
 
   &.station-mail {
    min-width: 150px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-secNum {
    min-width: 140px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &.station-secDate {
    min-width: 170px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

   &.station-iaTin {
    min-width: 140px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

   &.station-permitDate {
    min-width: 120px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-dateMoa {
    min-width: 160px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-turnover {
    min-width: 160px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

   &.station-iaPres {
    min-width: 160px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

  const TableRow = styled.tr`
  
    &:nth-child(even) {
      background-color: ${({ darkMode }) => (darkMode ? 'rgb(13, 99, 17)' : '#f9f9f9')};
    }
    &:hover {
      background-color:rgb(84, 194, 89);
    }
    
  `;

  const EditButtonContainer = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    color: rgb(14, 73, 16);
  `;

  const EditIcon = styled(FaEdit)`
    font-size: 15px;
    margin-right: 5px;
    &:hover {
      color: rgb(24, 88, 27);
    }
  `;


  const SlidingPanel = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    width: 72%;
    height: 100%;
    background-color: #fff;
    box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
    transform: translateX(100%);
    transition: transform 0.5s ease;
    z-index: 2;
    padding: 20px;
    box-sizing: border-box;

    ${({ show }) => show && `
      transform: translateX(0);
    `}
  `;

  const CloseButton = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    margin-bottom: 10px;
    margin-top: 20px;
    margin-left: -29px;
    padding: 10px;
  `;

  const SearchContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
    margin-top: -50px;
  `;

  const SearchInput = styled.input`
    padding: 8px;
    font-size: 14px;
    width: 250px;
    border: 1px solid  #f2f2f2;;
    border-radius: 5px;
  `;
